import gql from "graphql-tag";

import FirstMessage from "shared/components/FirstMessage";

const PhotoFragment = gql`
	fragment PhotoFragment on Photo {
		square100
		square120
		square225
		square400
	}
`;

const StackUserFragment = gql`
	${PhotoFragment}
	${FirstMessage.fragments.message}

	fragment StackUserFragment on StackResult {
		... on StackMatch {
			stream
			match {
				...FirstMessage
				matchPercent
				targetLikes
				senderLikes
				targetMessageTime
				targetLikeViaSpotlight
				user {
					id
					displayname
					username
					age
					primaryImage {
						id
						...PhotoFragment
					}
					location {
						summary
					}
					photos {
						id
						...PhotoFragment
					}
					essaysWithUniqueIds {
						id
						title
						processedContent
					}
					detailSentences {
						name
						text
					}
				}
			}
		}
	}
`;

const LikesCapFragment = gql`
	fragment LikesCapFragment on User {
		likesCap {
			likesRemaining
			resetTime
			viewCount
		}
	}
`;

export const MENU_QUERY = gql`
	${StackUserFragment}
	${LikesCapFragment}

	query WebStacksMenu($id: String!, $userGuides: [UserGuide!]!) {
		user(id: $id) {
			id
			hasSeenUserGuides(features: $userGuides)
			hasSeenSwipeyOnboarding: hasSeenUserGuide(feature: MW_ONBOARDING_QM_SWIPEY)
			hasSeenTappyOnboarding: hasSeenUserGuide(feature: MW_ONBOARDING_QM_TAPPY)
			...LikesCapFragment
			stacks {
				id
				status
				votesRemaining
				expireTime
				data {
					...StackUserFragment
				}
			}
		}
	}
`;

const StackFragment = gql`
	${StackUserFragment}

	fragment StackFragment on Stack {
		id
		status
		expireTime
		data {
			...StackUserFragment
		}
	}
`;

export const STACK_QUERY = gql`
	${StackFragment}

	query WebStack(
		$userId: String!,
		$stackId: StackTypes!,
		$excludedUserIds: [String],
	) {
		user(id: $userId) {
			id
			stack(id: $stackId, excludedUserIds: $excludedUserIds) {
				...StackFragment
			}
		}
	}
`;

export const JUST_FOR_YOU_QUERY = gql`
	${StackFragment}
	${LikesCapFragment}

	query WebJustForYouStack(
		$userId: String!,
		$excludedUserIds: [String],
	) {
		user(id: $userId) {
			id
			...LikesCapFragment
			stack(id: JUST_FOR_YOU, excludedUserIds: $excludedUserIds) {
				...StackFragment
			}
		}
	}
`;

export const STACK_RATE_CARD_QUERY = gql`
	query WebGetStackRateCard(
		$userId: String!,
		$platform: Platform!,
		$productType: ProductType!,
		$productSubtype: ProductSubType!,
	) {
		user(id: $userId) {
			id
			stackPassTokenCount
			rateCard(
				platform: $platform
				productType: $productType
				productSubtype: $productSubtype
			) {
				rateCardName
				productPriceInfoList {
					countryCode
					subPeriodType
					formattedInitialUnitPrice
					formattedInitialSubtotalPrice
					formattedInitialSubtotalPriceBase
					productType
					initialTaxes {
						taxType
						billingTaxRatesUSId
						billingStateCode
						billingCountryCode
						amount
						formattedAmount
					}
					initialCurrency
					subPeriod
					productSubType
					productId
					formattedInitialPrice
					tokensCount
					initialUnitPrice
					tokenPeriod
					tokenPeriodType
				}
			}
		}
	}
`;

export const ACTIVATE_STACK_MUTATION = gql`
	mutation WebStacksActivateById(
		$input: StacksActivateByIdInput!
	) {
		stacksActivateById(input: $input) {
			success
			errorMessage
		}
	}
`;

export const SET_DT_USER_GUIDE_SEEN = gql`
	mutation WebSetDTUserGuideSeen(
		$input: UserGuideSetHasSeenInput!
	) {
		userGuideSetHasSeen(input: $input) {
			success
		}
	}
`;



// WEBPACK FOOTER //
// ./src/apps/quickmatch/util/queries.js